export default __webpack_public_path__ + "static/media/Carousel.b49ef0ae.svg";